export const saveRankingToLS = (newScore) => {
  let ranking = JSON.parse(localStorage.getItem('ranking')) || [];
  ranking.push(newScore);
  if (ranking.length > 1) {
    ranking = ranking.sort((a, b) => b.score - a.score);
  }
  localStorage.setItem('ranking', JSON.stringify(ranking));
};

export const decodeChars = (text) => {
  const newText = new DOMParser().parseFromString(text, 'text/html');
  return newText.documentElement.textContent;
};

export const difficulty = ['Easy', 'Medium', 'Hard'];
